import { createNameSpace } from '../utils/NameSpace.js';
import { Prefix } from '../utils/Prefix.js';
let base = 'http://purl.org/on/npm/';
export var ns = createNameSpace(base);
Prefix.add('npm', base);
var packageName = ns('packageName');
var version = ns('version');
export var npm = {
    version,
    packageName,
};
//# sourceMappingURL=npm.js.map